import { FileSearchOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const ShowDetailBtn = ({ icon, displayText = false, ...others }) => {
  return (
    <Button icon={!icon ? <FileSearchOutlined /> : icon} {...others}>
      {displayText && "Detalle"}
    </Button>
  );
};
